import React from 'react'
import useStyles from './styles';
import { Typography, Box, useTheme } from '@material-ui/core';
import { strings as Localization } from '../../lib/Localization';
import DownloadForm from './DownloadForm/DownloadForm';
import DynamicContent from '../DynamicContentPage/DynamicContent/DynamicContent';

const FileDownload = () => {
    const classes = useStyles();

    const theme = useTheme();

    return (
        <main className={classes.content}>
            <Typography variant='h3' className={classes.capitalized} gutterBottom>{Localization.fileDownload}</Typography>
            <Box style={{ display: 'flex', flexDirection: 'row', paddingTop: theme.spacing(2) }}>
                <Box width={250}>
                    <DownloadForm />
                </Box>
                <Box width={500}>
                    <DynamicContent type='filedownload' />
                </Box>
            </Box>
        </main >
    )
}

export default FileDownload
